import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import Spinner from "../common/spinner";
import MiniSpinner from "../common/MiniSpinner";
import { Link } from "react-router-dom";
import { isEqual, min } from 'lodash';
import { getFirstName, queryParams } from "../../helpers/formatting";
import { Thumbnail } from "../ecosystem";



class SelectDoctor extends React.Component {
    componentDidMount() {
        logUI("MBHWeb.UI.SelectDoctor.ComponentDidMount", new Date(), Tools.getURLPath());
        this.getProviderDetails();
    }

    componentDidUpdate(prevProps) {
        const { directProviderNpiList, isFromVideoVisitOptions, getLatestVideoVisitProviderByid, currentUser } = this.props;
        if (prevProps && prevProps.currentUser && currentUser && prevProps.currentUser.eid !== currentUser.eid) {
            if (isFromVideoVisitOptions) {
                getLatestVideoVisitProviderByid();
            } else {
                this.getProviderDetails();
            }
        }
    }


    getProviderDetails = () => {
        const { directProviderNpiList, getProviderDetail } = this.props;
        if (directProviderNpiList && directProviderNpiList.length > 0) {
            const model = {
                ids: directProviderNpiList.join("|")
            };
            getProviderDetail(model);
        }
    }

    goToNextStep = (npi) => {
        const { loadVisitType, goNext } = this.props;
        if (loadVisitType) loadVisitType(npi);
        if (goNext) goNext();
    }

    providerCard = (provider, isFromVideoVisitOptions, index) => {

        let location = null;
        let more = 0;
        if (provider && provider.locations && provider.locations.length > 0) {
            location = provider.locations[0];
            more = provider.locations.length - 1;
        }
        let phone = provider?.consumerCallCenterNumber;
        if (location && location.locationPhone && (!phone || phone === "")) {
            phone = location.locationPhone;
        }

        const provName = Tools.trimComma(provider.displayName) + " photo";


        //debugger;
        return (
            <div className="col-12 col-xl-6" key={provider && provider.npi ? provider.npi : index}>
                <div className="card docs">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 finger doc_image" onClick={() => { this.goToNextStep(provider && provider.npi ? provider.npi : null); }}>
                           
                                <div>
                                    {isFromVideoVisitOptions ? 
                                    <Thumbnail
                                        source={provider.photoUrl ? provider.photoUrl : ''}
                                        icon="doctor"
                                        size="sm"
                                        altText={provName}
                                    />
                                        :
                                    <Thumbnail
                                        source={provider.photo ? provider.photo : ''}
                                        icon="doctor"
                                        size="sm"
                                        altText={provName}
                                    />
                                        }
                                </div>
                               

                                <div className="row docs__info-container">
                                    <div >
                                        <div className="docs__info-container--name">
                                            {Tools.trimComma(provider.displayName)}
                                        </div>
                                        {!isFromVideoVisitOptions && <div className="docs__info-container--specialty">
                                            {provider.specialties?.map((specialty) => {
                                                return specialty.Specialty;
                                            }).join(", ")}
                                        </div>}
                                        <div className="docs__info-container--specialty">
                                            {provider.specialty}
                                        </div>
                                    </div>
                                    {!isFromVideoVisitOptions && <div className="col-12">
                                        <div className="docs__info-container--details">
                                            <div className="details-icon-prepend">
                                                <div className="icon-col"><span className="icon-address" /></div>
                                                {location ?
                                                    <div className="details-col">
                                                        <div>{location && location.locationCity + ", " + location.locationState + "   " + (more > 0 ? "(+" + more + " more)" : "")}</div> {/* Doc's main city and state + however many other locations they work at. Link to the doctor's details page. */}
                                                    </div> :
                                                    <React.Fragment>
                                                        <div className="details-col">
                                                            <div className="no-data-dash">
                                                                <div />
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </div>
                                            <div className="details-icon-prepend">
                                                {phone ?
                                                    <a className="phone-link" href={"tel:" + phone}>
                                                        <div className="icon-col"><span className="icon-phone" /></div>
                                                        <div className="details-col">
                                                            {phone}
                                                        </div>
                                                    </a>
                                                    : <React.Fragment>
                                                        <div className="icon-col"><span className="icon-phone" /></div>
                                                        <div className="details-col">
                                                            <div className="no-data-dash">
                                                                <div />
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    navigateToWorkflow = (rfvId, workflow) => {
        const { serverData, history } = this.props;

        if (serverData.enableFindcareMammogramChanges && rfvId === "1208") {
            this.props.history.push({
                pathname: '/findcare',
                search: "?" + queryParams({ keyword: "mammography", tab: 2 })
            });
        } else {
            history.push(`/scheduling/${workflow}/${rfvId}`);
        }
    }

    render() {
        const { directProviderListPending, providerDetailsPending, providerDetails, safeCareMsg, directProviderNpiList, showNoProvidersAvailable, schedulingProcedure, currentUser, primaryUser, isFromVideoVisitOptions } = this.props;
        const displayName = currentUser && primaryUser && currentUser.eid === primaryUser.eid ? `You have` : currentUser && currentUser.displayName ? `${getFirstName(currentUser.displayName)} has` : "You have";

        let workflows = [];
        if (schedulingProcedure) {
            try {
                workflows = JSON.parse(schedulingProcedure.unescapeHTML());
            }
            catch (error) {
                workflows = [];
            }
        }
        else
            workflows = [];

        return (
            <div className="select-doctor-container" style={this.props.style}>
                <div className="row">
                    <div className="col-12">
                       {isFromVideoVisitOptions ? <h1 className="step-heading">Select one of your current doctors</h1>
                        : <h1 className="step-heading">Which doctor or service would you like?</h1>}
                        <div className="step-description">{safeCareMsg}</div>
                        {
                            directProviderListPending || providerDetailsPending || this.props.providerListByVisitTypeWaiting
                                ? <React.Fragment>
                                    <Spinner />
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <MiniSpinner />
                                        </div>
                                    </div>
                                </React.Fragment>
                                : <React.Fragment>
                                    {showNoProvidersAvailable
                                        ? <div className="no-doctors-on-file">
                                            <hr />
                                            <p>{`${displayName} no doctors on file, however, you can search for a doctor to schedule a visit.`}</p>
                                        </div>
                                        : <div className="row row-card-eq">
                                            <React.Fragment>
                                                {
                                                    providerDetails && providerDetails.map((provider, index) => {
                                                        return (

                                                            <React.Fragment key={index}>
                                                                {
                                                                    this.providerCard(provider, isFromVideoVisitOptions)
                                                                }
                                                            </React.Fragment>
                                                        );
                                                    })
                                                }
                                            </React.Fragment>
                                        </div>
                                    }
                                </React.Fragment>
                        }

                        <div className="row">
                            <div className="col-7">
                                <Link className="btn btn-primary select-doctor-btn" to={{ pathname: "/findcare", state: { seeAllYourDoctors: true } }}>
                                    FIND A NEW DOCTOR
                                </Link>
                            </div>
                        </div>
                        {workflows.length > 0 && !isFromVideoVisitOptions && <hr />}
                        {workflows.length > 0 && !isFromVideoVisitOptions && <div className="row">
                            {workflows.map(item =>
                            (item.name && <div className="col-12 col-xl-6" key={item.name}>
                                <div className="card docs">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 finger" onClick={() => this.navigateToWorkflow(item.rfvId, item.workflow)}>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="docs__info-container--name">
                                                            {item.name}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 screening-text details-col">
                                                        {item.description}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>)
                            )}
                        </div>}
                    </div>
                </div>
            </div>
        );
    }
}




export default withRouter(SelectDoctor);
